import {Input, Radio} from 'antd'
import {baseFieldTypes} from 'apis/base/baseFieldTypes'
import FieldsFactory from 'components/form/FieldsFactory'
import {FormActionGroups} from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {Formik} from 'formik'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useMemo} from 'react'
import {AdvancedFormFields} from 'views/AppLocals/custom/AdvancedFormGroup'
import {SelectWidget} from 'views/AppLocals/custom/ReactSelectComponents'
import {createControlledFormField, createNumberControlledInput} from 'views/AppLocals/factory/createFormField'
import {deepTranslate, NullAsDefault, shallowDiff} from 'views/Shared'
import AvatarUploader from '../components/AvatarUploader'
import {BsImage} from "react-icons/bs";
import {medal_getMedals_Api} from "../../../apis";
import {bindQueryParams} from "../../AppLocals/functions/routerHelper";
import useAsync from "../../../modules/asyncCache/useAsync";
import Pure from "../../../components/Pure";
import filterOption from "../../../helpers/filterOption";
import {
    lengthBetween,
    noDoubleSpaces,
    noLeadingTrailingSpaces, noNumber,
    noSpecialChars,
    required, runRules
} from "../../../components/form/ValidateForm";
import dayjs from "dayjs";

const formSchema = {
    avatar: {
        children: [
            {
                name: 'avatar',
                component: createControlledFormField({
                    withValues: ({avatar_preview}) => ({
                        value: avatar_preview,
                        icon: (
                            <BsImage
                                size={80}
                                style={{color: '#eaeaea'}}
                            />
                        ),
                    }),
                    Component: AvatarUploader,
                }),
            },
        ],
    },
    title: {
        title: 'name of certification',
        children: {
            name: 'title',
            component: createControlledFormField({
                placeholder: 'name of certification',
                showCount: true,
                maxLength: 180,
            }),
        },
    },
    description: {
        title: 'description',
        children: {
            name: 'description',
            component: createControlledFormField({
                rows: 3,
                showCount: true,
                maxLength: 500,
                placeholder: 'description',
                Component: Input.TextArea,
            }),
        },
    },
    level: {
        title: 'level',
        children: {
            name: 'lvl_number',
            component: createNumberControlledInput({
                placeholder: 'ex : 30',
                inputMode: 'number',
                min: 1,
                max: 1000
            }),
        },
    },
    tags: {
        title: 'tags',
        children: {
            name: 'tags',
            component: ({name, value, onChange}) => (
                <Translate>
                    {(t) => (
                        <SelectWidget
                            mode="tags"
                            name={name}
                            value={value}
                            allowClear={true}
                            className="w-full"
                            placeholder={t('tags')}
                            onChange={(value) => {
                                onChange(createValue(name, value))
                            }}
                        />
                    )}
                </Translate>
            ),
        },
    },
    active: {
        title: 'active',
        children: [
            {
                name: 'active',
                component: ({name, value, onChange}) => (
                    <Translate>
                        {(t) => (
                            <Radio.Group
                                name={name}
                                value={value}
                                onChange={onChange}
                                buttonStyle="solid"
                                optionType="button"
                                className="custom-radio-button"
                                options={baseFieldTypes.active.map(deepTranslate(t))}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },


    medal_1_id: {
        title: 'medal 1',
        children: [
            {
                name: 'medal_1_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const medals = _.get(form, 'values.medals', []);
                    return (
                        <Translate>
                            {(t) => (
                                <SelectWidget
                                    value={value}
                                    className="w-full"
                                    placeholder={t('click to select')}
                                    showSearch={true}
                                    options={medals.map((e, i) => {

                                        return {label: e.title, value: e.id}
                                    })}
                                    filterOption={filterOption}
                                    onChange={(value, option) => {
                                        onChange(createValue(name, value))
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
        ],
    },
    medal_2_id: {
        title: 'medal 2',
        children: [
            {
                name: 'medal_2_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const medals = _.get(form, 'values.medals', []);
                    return (
                        <Pure input={[value]}>
                            <Translate>
                                {(t) => (
                                    <SelectWidget
                                        value={value}
                                        className="w-full"
                                        placeholder={t('click to select')}
                                        showSearch={true}
                                        options={medals.map((e, i) => {

                                            return {label: e.title, value: e.id}
                                        })}
                                        filterOption={filterOption}
                                        onChange={(value, option) => {
                                            onChange(createValue(name, value))
                                        }}
                                    />
                                )}
                            </Translate>
                        </Pure>
                    )
                },
            },
        ],
    },
    new_medal_id: {
        title: 'new medal',
        children: [
            {
                name: 'new_medal_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const medals = _.get(form, 'values.medals', []);
                    return (
                        <Pure input={[value]}>
                            <Translate>
                                {(t) => (
                                    <SelectWidget
                                        value={value}
                                        className="w-full"
                                        placeholder={t('click to select')}
                                        showSearch={true}
                                        options={medals.map((e, i) => {

                                            return {label: e.title, value: e.id}
                                        })}
                                        filterOption={filterOption}
                                        onChange={(value, option) => {
                                            onChange(createValue(name, value))
                                        }}
                                    />
                                )}
                            </Translate>
                        </Pure>
                    )
                },
            },
        ],
    },
}

const validateTitle = (name, t) => {
    const rules = [
        required(t),
        lengthBetween(2, 180, t),
        noSpecialChars(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ].filter(Boolean)
    const message = runRules(name, rules)
    if (message) return { title: message }
}

const validateLvlNumber = (lvlNumber, t) => {
    const rules = [required(t)].filter(Boolean)
    const message = runRules(lvlNumber, rules)
    if (message) return { lvl_number: message }
}

const validateTags = (tags, t) => {
    if (!Array.isArray(tags) || tags.length === 0) return {}
    const rules = [
        lengthBetween(2, 255, t),
        noSpecialChars(t),
        noLeadingTrailingSpaces(t),
        noDoubleSpaces(t),
    ]
    for (const tag of tags) {
        const message = runRules(tag, rules)
        if (message) {
            return { tags: message }
        }
    }
}

const validate = (t) => (values) => {
    const {
        title,
        description,
        lvl_number,
        tags
    } = values ?? {}
    const errorTitle = validateTitle(title, t)
    const errorLvlNumber = validateLvlNumber(lvl_number, t)
    const errorTags = validateTags(tags, t)
    return {
        ...errorTitle,
        ...errorLvlNumber,
        ...errorTags,
    }
}

export const CreateMedal = ({
                                onCancel,
                                owner_id,
                                owner_type,
                                isSubmitting,
                                onSubmit = NullAsDefault,
                            }) => {
    const t = useTranslate()

    const initialValues = useMemo(
        () => ({
            active: 1,
            owner_id,
            owner_type,
            tags: undefined,
            avatar: undefined,
            title: undefined,
            status: undefined,
            lvl_number: 1,
            description: undefined,
        }),
        [owner_id, owner_type]
    )

    return (
        <Formik
            validate={validate(t)}
            validateOnMount={true}
            validateOnChange={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const {owner_id, owner_type, avatar_preview, ...rest} = values ?? {}
                const tags = Array.from(values?.tags ?? [])
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            tags: tags.join(','),
                            active: Number(values?.active ?? 0),
                        },
                        _.isUndefined
                    )
                )
            }}>
            <div className="flex flex-col space-y-3">
                <FieldsFactory
                    formSchema={[
                        formSchema.avatar,
                        formSchema.title,
                        formSchema.description,
                        formSchema.level,
                        formSchema.tags,
                    ]}
                />
                <AdvancedFormFields formSchema={[formSchema.active]}/>
                <FormActionGroups
                    isSubmitting={isSubmitting}
                    submitProps={{
                        label: 'create',
                    }}
                />
            </div>
        </Formik>
    )
}

export const EditMedal = ({
                              item,
                              onCancel,
                              owner_id,
                              owner_type,
                              isSubmitting,
                              onSubmit = NullAsDefault,
                          }) => {
    const t = useTranslate()
    const initialValues = useMemo(() => {
        const {tags, avatar} = item ?? {}
        return {
            ...(item ?? {}),
            owner_id,
            owner_type,
            avatar_preview: avatar,
            tags: Array.from(tags ?? []).map((e) => e?.tags),
        }
    }, [item, owner_id, owner_type])

    return (
        <Formik
            validate={validate(t)}
            validateOnMount={true}
            validateOnChange={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                const changes = shallowDiff(values, initialValues)
                const {owner_id, owner_type, avatar_preview, ...rest} = changes ?? {}
                const tags = Array.from(values?.tags ?? [])
                onSubmit({...rest, tags: tags.join(',')})
            }}>
            <div className="flex flex-col space-y-3">
                <FieldsFactory
                    formSchema={[
                        formSchema.avatar,
                        formSchema.title,
                        formSchema.description,
                        formSchema.level,
                        formSchema.tags,
                    ]}
                />
                <AdvancedFormFields formSchema={[formSchema.active]}/>
                <FormActionGroups
                    isSubmitting={isSubmitting}
                    submitProps={{
                        label: 'save',
                    }}
                />
            </div>
        </Formik>
    )
}


export const MergeMedal = ({
                               type = 'student',
                               onCancel,
                               owner_id,
                               owner_type,
                               isSubmitting,
                               onSubmit = NullAsDefault,
                           }) => {
    const t = useTranslate()

    const {response, isLoading = false} = useAsync({
        apiInfo: medal_getMedals_Api,
        query: bindQueryParams([{prop: owner_type}, {id: owner_id}]),
    })

    const medals = _.get(response, 'data.data', []);


    const validate = (values) => {
        const {medal_1_id, medal_2_id, new_medal_id} = values ?? {}
        let errors = {}

        if (_.isEmpty(medal_1_id)) {
            errors.medal_1_id = t('required field')
        }
        if (_.isEmpty(medal_2_id)) {
            errors.medal_2_id = t('required field')
        }
        if (_.isEmpty(new_medal_id)) {
            errors.new_medal_id = t('required field')
        }
        return errors
    }

    const initialValues = useMemo(() => {
        return {
            owner_id,
            owner_type,
            medal_1_id: undefined,
            medal_2_id: undefined,
            new_medal_id: undefined,
            medals
        }
    }, [medals, owner_id, owner_type])

    return !!medals.length && (
        <Formik
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            initialValues={initialValues}
            onSubmit={(values) => {
                onSubmit(values)
            }}>
            <div className="flex flex-col space-y-3">

                <FieldsFactory
                    formSchema={[
                        formSchema.medal_1_id,
                        formSchema.medal_2_id,
                        formSchema.new_medal_id
                    ]}
                />

                <FormActionGroups
                    isSubmitting={isSubmitting}
                    submitProps={{
                        label: 'merge',
                    }}
                />
            </div>
        </Formik>
    )
}
